import React from 'react'

import Embed from './Embed'

export default ({ id }) => (
  <Embed>
    <iframe src={`https://player.vimeo.com/video/${id}`}
            frameBorder="0"
            allowFullScreen>
    </iframe>
  </Embed>
)



/** WEBPACK FOOTER **
 ** ./src/components/VimeoEmbed.js
 **/